import React from 'react';
import styled from 'styled-components';
import { Header, HeaderProps } from '../components/sections/header';
import { FooterProps, Footer } from '../components/sections/footer';
import { BlogPost } from '../types/blogPost';
import { VLink } from '../components/other/vLink';
import { Layout } from '../components/layout';

const BlogPostsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 2rem;
`;

interface PageProps {
  pageContext: {
    title: string;
    description: string;
    blogs: BlogPost[];
    header: HeaderProps;
    footer: FooterProps;
  };
}

export default ({ pageContext }: PageProps) => {
  const { title, description, blogs, header, footer } = pageContext;
  return (
    <Layout title={title} description={description}>
      <Header logo={header.logo} navigationItems={header.navigationItems} disableInverse={true} />
      <div className="pt-32 px-8 w-10/12 mx-auto">
        <h1 className="text-4xl font-bold mb-16">Category: {title}</h1>

        <BlogPostsContainer className="mb-16">
          {blogs.map((blogPost, index) => (
            <div key={index}>
              <VLink to={`/${blogPost.slug}`}>
                <img className="mb-4" src={blogPost.mainImage.url} alt={blogPost.mainImage.name} />
                <h3 className="font-bold">{blogPost.title}</h3>
              </VLink>
            </div>
          ))}
        </BlogPostsContainer>
      </div>
      <Footer {...footer} />
    </Layout>
  );
};
